type CallLogColumn =
'CALL_DATE' |
'CALL_TYPE' |
'CREATE_TICKET' |
'INTERVENANT_CODE' |
'STATION_CODE' |
'STATION' |
'DESCRIPTION' |
'CALL_STATUS'|
// 'REGROUPEMENT' |
'PANNE';
const CallLogColumns = (() => {
  const CALL_DATE : CallLogColumn = 'CALL_DATE';
  const CALL_TYPE : CallLogColumn = 'CALL_TYPE';
  const CREATE_TICKET: CallLogColumn = 'CREATE_TICKET';
  const INTERVENANT_CODE: CallLogColumn = "INTERVENANT_CODE";
  const STATION_CODE : CallLogColumn = 'STATION_CODE';
  const STATION : CallLogColumn = 'STATION';
  const DESCRIPTION: CallLogColumn = 'DESCRIPTION';
  const CALL_STATUS : CallLogColumn = 'CALL_STATUS';
  // const REGROUPEMENT: CallLogColumn = 'REGROUPEMENT';
  const PANNE: CallLogColumn = 'PANNE';
  function values(): CallLogColumn[] {
    return [
     CALL_DATE,
     CALL_TYPE ,
     CREATE_TICKET,
     INTERVENANT_CODE,
     STATION_CODE,
     STATION ,
     DESCRIPTION,
     CALL_STATUS,
    //  REGROUPEMENT,
      PANNE
    ];
  }
  return { CALL_DATE, CALL_TYPE, CREATE_TICKET, INTERVENANT_CODE, STATION_CODE, STATION, DESCRIPTION, CALL_STATUS, PANNE, values };
})();
export { CallLogColumns };

type CallLogSortColumn =
'CALL_DATE' |
'CALL_TYPE' |
'INTERVENANT_CODE' |
'STATION_CODE' |
'CALL_STATUS';
const CallLogSortColumns = (() => {
  const CALL_DATE: CallLogSortColumn = 'CALL_DATE';
  const CALL_TYPE: CallLogSortColumn = 'CALL_TYPE';
  const INTERVENANT_CODE: CallLogSortColumn = "INTERVENANT_CODE";
  const STATION_CODE: CallLogSortColumn = 'STATION_CODE';
  const CALL_STATUS: CallLogSortColumn = 'CALL_STATUS';
  function values(): CallLogSortColumn[] {
    return [
      CALL_DATE,
      CALL_TYPE,
      INTERVENANT_CODE,
      STATION_CODE,
      CALL_STATUS,
    ];
  }
  return { CALL_DATE, CALL_TYPE, INTERVENANT_CODE, STATION_CODE, CALL_STATUS, values };
})();

export { CallLogSortColumns };
